import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle2, Info, X, XCircle } from 'lucide-react';
const CONFIG = {
    success: {
        bar: 'bg-emerald-500',
        chip: 'bg-emerald-100 text-emerald-600',
        icon: _jsx(CheckCircle2, { className: 'h-5 w-5' }),
    },
    error: {
        bar: 'bg-red-500',
        chip: 'bg-red-100 text-red-600',
        icon: _jsx(XCircle, { className: 'h-5 w-5' }),
    },
    info: {
        bar: 'bg-primary',
        chip: 'bg-accent text-primary',
        icon: _jsx(Info, { className: 'h-5 w-5' }),
    },
};
export const Toast = ({ message, description, status, id: toastId, removeToast, }) => {
    var _a;
    const cfg = (_a = CONFIG[status]) !== null && _a !== void 0 ? _a : CONFIG.info;
    return (_jsxs("div", { role: 'status', 
        /*
         * Inline height rules on purpose. Embedded in a host (Vriti), this card was rendering the full
         * height of the viewport — its `inset-y-0` accent bar stretched with it — because a host's
         * layout can give the fixed container a definite height and stretch its children. The Tailwind
         * utilities here cannot win that on their own, and the host's cascade is not ours to edit, so
         * the card states its own size where nothing outside can override it.
         */
        style: { alignSelf: 'flex-start', flex: '0 0 auto', height: 'auto', maxHeight: '40vh' }, className: 'animate-toast-in pointer-events-auto relative mb-2.5 flex w-80 max-w-[calc(100vw-1rem)] items-start gap-3 overflow-hidden rounded-2xl border border-border bg-card/95 py-3 pl-4 pr-2.5 shadow-[var(--shadow-card)] backdrop-blur', children: [_jsx("span", { className: `absolute inset-y-0 left-0 w-1 ${cfg.bar}`, "aria-hidden": 'true' }), _jsx("span", { className: `mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-full ${cfg.chip}`, children: cfg.icon }), _jsxs("div", { className: 'min-w-0 flex-1 pt-0.5', children: [_jsx("div", { className: 'break-words text-sm font-semibold leading-snug text-foreground', children: message }), description && (_jsx("div", { className: 'mt-0.5 break-words text-xs leading-relaxed text-muted-foreground', children: description }))] }), _jsx("button", { type: 'button', onClick: () => removeToast(toastId), "aria-label": 'Close', className: '-mr-0.5 mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground', children: _jsx(X, { className: 'h-4 w-4' }) }), _jsx("span", { className: `animate-toast-progress absolute bottom-0 left-0 h-0.5 w-full ${cfg.bar} opacity-70`, "aria-hidden": 'true' })] }));
};
